import { SagaIterator } from 'redux-saga'
import { all, takeLatest } from 'redux-saga/effects'
import * as authConstants from './auth/authConstants'
import * as authSagas from './auth/authSagas'
import * as dataConstants from './data/dataConstants'
import * as dataSagas from './data/dataSagas'

export function* rootSaga(): SagaIterator {
  yield all([
    takeLatest(authConstants.CREDENTIAL_LOG_IN_REQUEST, authSagas.credentialsLogInRequestSaga),
    takeLatest(authConstants.PROVIDER_LOG_IN_REQUEST, authSagas.providerLogInRequestSaga),
    takeLatest(authConstants.HEADER_ENRICHMENT_LOG_IN_REQUEST, authSagas.headerEnrichmentLogInRequestSaga),
    takeLatest(authConstants.LOG_IN_SUCCESS, dataSagas.getDataRequestSaga),
    takeLatest(dataConstants.GET_APP_DATA_REQUEST, dataSagas.getDataRequestSaga),
    takeLatest(dataConstants.POST_ORDERS_MULTISIM, dataSagas.postOrdersMultisimSaga),
    takeLatest(dataConstants.PATCH_ORDERS_MULTISIM_ORDER_ID, dataSagas.patchOrdersMultisimSaga),
  ])
}
